/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import {
  Box,
  Stack,
  Container,
  Flex,
  Link,
  Text,
  Title,
} from '@bottlebooks/gatsby-theme-base';
import { Trans } from '@lingui/macro';
import { jsx } from 'theme-ui';
import useUser from '../../../gatsby-plugin-firebase-auth/src/useUser';

export default function PersonalHeader({ children }) {
  const [user, isLoading, error] = useUser();
  if (isLoading) return <Loading>{children}</Loading>;
  if (error) return <Error error={error}>{children}</Error>;
  // @ts-ignore
  if (user)
    return (
      <LoggedIn user={user} onLogout={() => {}}>
        {children}
      </LoggedIn>
    );
  return <LoggedOut>{children}</LoggedOut>;
}

export function Header({ children, ...rest }) {
  return (
    <Box sx={{ borderBottom: 1, borderColor: 'border' }} {...rest}>
      <Container>{children}</Container>
    </Box>
  );
}

function Loading({ children, ...rest }) {
  return (
    <Header sx={{ paddingTop: 4 }} {...rest}>
      <Title variant="large" sx={{ flexGrow: 1, paddingTop: 4 }}>
        <Trans>Welcome</Trans>
      </Title>
      <Text variant="small" sx={{ color: 'lightText', paddingBottom: 4 }}>
        <Trans>Loading…</Trans>
      </Text>
      {children}
    </Header>
  );
}

function Error({ error, children, ...rest }) {
  return (
    <Header sx={{ paddingTop: 4 }} {...rest}>
      <Title variant="large" sx={{ flexGrow: 1, paddingTop: 4 }}>
        <Trans>Welcome</Trans>
      </Title>
      <Text
        variant="small"
        sx={{ color: 'brand.warningRed', paddingBottom: 4 }}
      >
        <Trans>There was an error logging in. Try refreshing the page.</Trans>
      </Text>
      {children}
    </Header>
  );
}

/**
 * @param {{
 *  user: import('firebase/auth').User;
 *  onLogout?: () => void;
 *  [x: string]: any;
 * }} props
 */
function LoggedIn({ user, onLogout, children, ...rest }) {
  const userName = user.displayName;
  return (
    <Header sx={{ paddingTop: 4 }} {...rest}>
      <Flex sx={{ alignItems: 'baseline', paddingY: 4 }}>
        <Box sx={{ flexGrow: 1 }}>
          <Stack spacing={1}>
            <Title variant="large">
              {user.isAnonymous ? (
                <Trans>
                  Welcome, <span sx={{ color: 'primary' }}>visitor!</span>
                </Trans>
              ) : (
                <Trans>
                  Welcome, <span sx={{ color: 'primary' }}>{userName}!</span>
                </Trans>
              )}
            </Title>

            <Text variant="small" sx={{ color: 'lightText' }}>
              {user.email}
            </Text>
          </Stack>
        </Box>
        {user.isAnonymous
          ? null // <Button variant="primary" onClick={onLogin} sx={{ variant: 'label.default' }}><Trans>Log in</Trans></Button>
          : onLogout && (
              <Link onClick={onLogout} sx={{ variant: 'label.default' }}>
                <Trans>Log out</Trans>
              </Link>
            )}
      </Flex>
      {/* {user.isAnonymous && (
        <Box
        sx={{
          backgroundColor: 'brand.lightYellow',
          border: 1,
          borderColor: 'brand.warningYellow',
          paddingX: 3,
          paddingY: 2,
        }}
        >
        <Text>
        <Trans>
        You are not logged in.
        <br />
        To save your tasting list permanently, you need to{' '}
        <Link onClick={onLogin}>log in</Link> using your email address.
        </Trans>
        </Text>
        </Box>
      )} */}
      {children}
    </Header>
  );
}

function LoggedOut({ children, ...rest }) {
  return (
    <Header sx={{ paddingTop: 4 }} {...rest}>
      <Title variant="large" sx={{ flexGrow: 1, paddingTop: 4 }}>
        <Trans>Welcome</Trans>
      </Title>
      {children}
    </Header>
  );
}
